module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("🦄 vue-chartjs demo")]), _vm._v(" "), _c('div', {
    staticClass: "Chart__list"
  }, [_c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Linechart")]), _vm._v(" "), _c('line-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Barchart")]), _vm._v(" "), _c('bar-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Barchart with reactive mixing for live data")]), _vm._v(" "), _c('reactive-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Doughnutchart")]), _vm._v(" "), _c('doughnut-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Piechart")]), _vm._v(" "), _c('pie-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Radarchart")]), _vm._v(" "), _c('radar-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Polararea")]), _vm._v(" "), _c('polar-area-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Bubblechart")]), _vm._v(" "), _c('bubble-example')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-436a0585"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 14
// module chunks = 0